import React, { ReactElement, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useCreateWebhookUrlMutation } from "../../../__generated__/api";
import CodeBlock from "../../code-block/CodeBlock";
import { ActionProps } from "./base";

function createId() {
    return uuidv4().replace(/-/g, "");
}

export default function WebhookSettings(props: ActionProps): ReactElement {
    const [generate] = useCreateWebhookUrlMutation();
    const [url, setUrl] = useState<string>();
    const [shouldShowInstructions, setShowInstructions] = useState<boolean>();

    useEffect(() => {
        if (!props.id || !props.workflow.id) {
            return;
        }
        (async () => {
            let { id } = props;
            if (!id) {
                const workflowId = (props.workflow.id as string)?.match(/urn:fq:workflow:[a-zA-Z0-9]*/)?.[0];
                if (!workflowId || workflowId === "urn:fq:workflow:-1") {
                    setShowInstructions(true);
                }
                id = `urn:fq:workflow-step:(${workflowId},${createId()})`;
            } else if (id.includes("-1")) {
                setShowInstructions(true);
            }
            props.onChange({
                values: [],
                id,
            });
            const webhook = await generate({
                variables: {
                    stepId: id,
                },
            });
            setUrl(webhook.data?.workflowServiceCreateWebhook.url);
        })();
    }, [props.service.id, props.workflow.id]);

    return (
        <div className="">
            <div className="">
                Webhook Url
            </div>
            {shouldShowInstructions ? (
                <div>
                    Webhook url will be generated once you save this automation. Please click save on the whole
                    automation. Then come back to this step and you will see the webhook url.
                </div>
            ) : (
                <CodeBlock code={url} />
            )}

            <small>
                Use this webhook to continue this workflow step. You must pass in the chat id, ticket id, or ticket alias
                into the body. To associate a chat id with this request, use the &quot;Store Alias&quot; task.
            </small>
        </div>

    );
}
